import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';

const CTASection = () => {
  const services = [
    {
      title: "Formations Professionnelles",
      description: "Programmes sur-mesure pour développer les compétences de vos équipes",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
        </svg>
      ),
      link: "/professional-training-services",
      color: "gold"
    },
    {
      title: "Conseil Stratégique",
      description: "Accompagnement expert pour intégrer l\'excellence dans votre stratégie",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
        </svg>
      ),
      link: "/strategic-consulting-services",
      color: "burgundy"
    },
    {
      title: "Solutions IA Intégrées",
      description: "Développement et implémentation de solutions IA adaptées à vos besoins",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
        </svg>
      ),
      link: "/ai-solutions-integration-hub",
      color: "amber"
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      gold: "bg-[#9B8E57]/10 text-[#9B8E57] group-hover:bg-[#9B8E57] group-hover:text-white border border-[#9B8E57]/20",
      burgundy: "bg-[#96121D]/10 text-[#96121D] group-hover:bg-[#96121D] group-hover:text-white border border-[#96121D]/20",
      amber: "bg-amber-50 text-amber-700 group-hover:bg-amber-600 group-hover:text-white border border-amber-200"
    };
    return colorMap?.[color] || colorMap?.gold;
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#96121D]/10 text-[#96121D] text-sm font-semibold mb-4 border border-[#96121D]/20">
            <span className="w-2 h-2 bg-[#9B8E57] rounded-full mr-2 animate-pulse"></span>
            Passez à l'Action
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Transformez Vos Connaissances en <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#96121D] to-[#9B8E57]">Résultats</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Nos articles vous inspirent ? Découvrez comment CRF PERFECTION peut vous accompagner 
            dans votre transformation et le développement de vos compétences.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {services?.map((service, index) => (
            <Link
              key={index}
              to={service?.link}
              className="group bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-[#9B8E57]/30"
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-all duration-300 ${getColorClasses(service?.color)}`}>
                {service?.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#96121D] transition-colors duration-300">
                {service?.title}
              </h3>
              <p className="text-gray-600 mb-5 leading-relaxed">
                {service?.description}
              </p>
              <div className="flex items-center text-[#96121D] font-bold group-hover:text-[#9B8E57]">
                Découvrir
                <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"/>
                </svg>
              </div>
            </Link>
          ))}
        </div>

        {/* Main CTA */}
        <div className="bg-gradient-to-br from-[#96121D] via-gray-900 to-[#9B8E57] rounded-3xl p-10 md:p-16 text-center relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2040%2040%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.1%22%3E%3Cpath%20d%3D%22M20%2020.5V18H0v-2h20v2.5zm-.5%200h-2v-2H20v2zm-.5%200h-2v-2H20v2z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E')]"></div>
          </div>

          <div className="relative">
            {/* Company Logo */}
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-8 bg-white/10 backdrop-blur-sm rounded-2xl border border-[#9B8E57]/30">
              <Image
                src="/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png"
                alt="CRF PERFECTION logo featuring interlocking heart-shaped design in red and gold colors representing Centre de Recherche et de Formation business therapy excellence"
                className="w-16 h-16 object-contain"
              />
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Prêt à Révolutionner Votre Organisation ?
            </h3>
            <p className="text-white/90 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
              Contactez nos experts CRF PERFECTION pour une consultation gratuite et découvrez comment 
              nous pouvons transformer votre business et développer vos équipes.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center max-w-md mx-auto">
              <Link
                to="/contact"
                className="px-10 py-4 bg-white text-[#96121D] font-bold rounded-xl hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl"
              >
                Consultation Gratuite
              </Link>
              <Link
                to="/professional-training-services"
                className="px-10 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold rounded-xl hover:bg-white/20 hover:border-white/50 transition-all duration-300"
              >
                Nos Services
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="mt-10 flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-white/90 text-sm">
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-[#9B8E57]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="font-semibold">Excellence Certifiée</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-[#9B8E57]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
                <span className="font-semibold">+500 Entreprises Formées</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-[#9B8E57]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="font-semibold">Présence Internationale</span>
              </div>
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="absolute top-8 left-8 w-20 h-20 bg-[#9B8E57]/20 rounded-full blur-2xl"></div>
          <div className="absolute bottom-8 right-8 w-24 h-24 bg-[#96121D]/20 rounded-full blur-2xl"></div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;